import { AxiosInstance } from 'axios'
import { PaginatedResponse } from '../base.type'
import {
    CreateRequestApprovalDto,
    GetRequestApprovalsParams,
    RejectRequestDto,
    RequestApproval,
} from './request-approval.type'
import { User } from '../user'
import { ProjectDetail } from '../project'

const BASE_URL = '/request-approvals'

export class RequestApprovalApi {
    constructor(private readonly client: AxiosInstance) {}

    list = async (params: GetRequestApprovalsParams): Promise<PaginatedResponse<RequestApproval>> => {
        const response = await this.client.get(BASE_URL, { params })
        return response.data
    }

    detail = async (id: string): Promise<RequestApproval> => {
        const response = await this.client.get(`${BASE_URL}/${id}`)
        return response.data
    }

    create = async (data: CreateRequestApprovalDto): Promise<RequestApproval> => {
        const response = await this.client.post(BASE_URL, data)
        return response.data
    }

    approve = async (id: string): Promise<void> => {
        await this.client.post(`${BASE_URL}/${id}/approve`)
    }

    reject = async (id: string, data: RejectRequestDto): Promise<void> => {
        await this.client.post(`${BASE_URL}/${id}/reject`, data)
    }

    approveComplete = async (id: string): Promise<void> => {
        await this.client.post(`${BASE_URL}/${id}/approve-complete`)
    }

    getUsers = async (id: string, params?: { page: number; take?: number }): Promise<PaginatedResponse<User>> => {
        const response = await this.client.get(`${BASE_URL}/${id}/users`, { params })
        return response.data
    }

    getProject = async (id: string): Promise<ProjectDetail> => {
        const response = await this.client.get(`${BASE_URL}/${id}/project`)
        return response.data
    }
}
